module.exports = __webpack_public_path__ + "img/HVS_color_en.81a5c97c.jpg";